import { render, staticRenderFns } from "./AddOrModifyTaskDialog1.vue?vue&type=template&id=56921e24&scoped=true&"
import script from "./AddOrModifyTaskDialog1.vue?vue&type=script&lang=js&"
export * from "./AddOrModifyTaskDialog1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56921e24",
  null
  
)

export default component.exports